import { formatPrice } from './formatPrice';

export const formatInvoiceFooter = (valueKey: string, value: number) => {
  if (['taxes', 'discount']?.includes(valueKey)) {
    return `% ${value}`;
  }
  return formatPrice(value);
};
